class AccountingConverter {
    fromTotalAmountToNetAmount(params) {
        const { totalAmount, vat, pennyAdjust } = params;
        return totalAmount - vat - pennyAdjust;
    }
    fromTotalAmountToRows(params) {
        const { totalAmount, vat, pennyAdjust } = params;
        const netAmount = this.fromTotalAmountToNetAmount({ totalAmount, vat, pennyAdjust });
        return { netAmount, vat, pennyAdjust, totalAmount };
    }
    fromAmountToDebitCredit(netAmount) {
        return {
            debit: netAmount >= 0 ? netAmount : 0,
            credit: netAmount < 0 ? Math.abs(netAmount) : 0,
        };
    }
    fromRowsToNetAmount(params) {
        return params.reduce((acc, row) => acc + row.debit - row.credit, 0);
    }
}
export const accountingConverter = new AccountingConverter();
